// @flow
import * as React from "react";
import styled, { css } from "styled-components";
import { CloseIcon } from "../Icons/index";

import type { FirebaseMessage } from "../FirebaseCloudMessaging";

export const Messages = styled.div`
  direction: ${({ theme }) => theme.direction};
  position: fixed;
  left: 15px;
  bottom: 15px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  max-width: 395px;
  width: calc(100% - 20px);
  z-index: 200;

  @media (min-width: 568px) {
    max-width: 395px;
  }
`;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  min-height: 100px;
  width: 100%;
  margin-bottom: 10px;
  padding: 15px;
  font-size: 16px;
  line-height: 1.5;
  color: #000;
  background-color: #fff;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
  border: 2px solid rgba(0, 0, 0, 0.16);
  box-sizing: border-box;
`;

const IconContainer = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 70px;
  width: 70px;
`;

const Content = styled.div`
  flex: 1;

  ${({ theme }) => {
    if (theme.direction === "rtl")
      return css`
        padding-right: 15px;
      `;

    return css`
      padding-left: 15px;
    `;
  }};
`;

const Icon = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

const Heading = styled.h5`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-content: space-between;
  align-items: flex-start;
  font-weight: 700;
  font-size: 18px;
  line-height: 1.25;
  margin-bottom: 0.5rem;
`;

const Title = styled.span`
  flex-grow: 1;
  flex-shrink: 1;
`;

const Close = styled(CloseIcon)`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 16px;
  color: #717171;
  cursor: pointer;
  transition: all 0.3s ease;

  :hover,
  :focus,
  :active {
    color: ${props => props.theme.accent};
  }

  ${({ theme }) => {
    if (theme.direction === "rtl")
      return css`
        margin-right: 5px;
      `;

    return css`
      margin-left: 5px;
    `;
  }};
`;

type Props = {
  title: React.Node,
  icon?: ?string,
  children: React.Node,
  onDismiss?: (
    e: SyntheticMouseEvent<HTMLElement>,
    message: FirebaseMessage
  ) => void,
  onClick?: (
    e: SyntheticMouseEvent<HTMLElement>,
    message: FirebaseMessage
  ) => void
};

function Message({ title, icon, children, onDismiss, onClick }: Props) {
  return (
    <Container onClick={onClick}>
      {icon && (
        <IconContainer>
          <Icon src={icon} alt={title} />
        </IconContainer>
      )}
      <Content>
        <Heading>
          <Title>{title}</Title>
          <Close width="16px" onClick={onDismiss} />
        </Heading>
        {children}
      </Content>
    </Container>
  );
}

export default Message;



// WEBPACK FOOTER //
// ./src/components/Firebase/Message.js